import React, { createContext, useContext, useState } from 'react'

const FormContext = createContext()

export const useForm = () => {
  const [formData, setFormData] = useState({})
  const context = useContext(FormContext)

  if (context) return context

  const setField = (val, key) => {
    setFormData(prev => ({
      ...prev,
      [key]: val,
    }))
  }

  return {
    formData,
    setFormData,
    setField,
  }
}

export const FormProvider = ({ children }) => {
  const formStateParams = useForm()

  return (
    <FormContext.Provider value={formStateParams}>
      {children}
    </FormContext.Provider>
  )
}
